<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.listaguion li{list-style-type: none}
.listaguion li:before{content: "-"; position:relative; left:-5px;}
</style>

<template>
  <div>
    <h2>Los tratados de La Soledad</h2>
    <img @click="imageClicked(0)" src="galerias/sala1/S1_G9.jpg" class="mainphoto"/>
    <p class="photo-description">Título: <b>General Manuel Doblado y el General Prim</b><br>
        Autor: Ramón Sosamontes <br>
        Año:1948<br>
        Técnica: Grabado en linóleo<br>
        Medidas: 36.2 cm x 29 cm <br>
        Catálogo de obras del Taller de Gráfica Popular<br>
    </p>
    <p>El Presidente Benito Juárez designó al gobernador de Guanajuato, General Manuel Doblado, Ministro de Relaciones Exteriores para dialogar con los países afectados por la suspensión del pago de la deuda, siendo el representante de las potencias aliadas el español Juan Prim.</p>
    <p>Antes de llevar a cabo las negociaciones para establecer el compromiso de pago por parte del gobierno mexicano, el 19 de febrero de 1862, se firmaron convenios preliminares en la hacienda de La Soledad, Veracruz, estableciendo que:</p>
    <p>
        <ul class="listaguion">
            <li>Las tropas aliadas no atentarían contra la independencia y soberanía de México.</li>
            <li>Los ejércitos de los aliados podrían ocupar las poblaciones de Córdoba, Orizaba y Tehuacán.</li>
            <li>De no existir un acuerdo, los ejércitos desalojarían las poblaciones y se establecerían cerca del Puerto de Veracruz.</li>
        </ul>
    </p>
    <p>Previendo una invasión, el Presidente Juárez ordenó la conformación del Ejército de Oriente para la protección del país, mismo que estuvo a cargo del Gral. Ignacio Zaragoza.</p>
    <h5>Ver más:</h5>
    <p>Si quieres conocer más sobre los tratados de la Soledad: <br>
      <a target="_blank" href="https://www.youtube.com/watch?v=LCx8laEDYQ0">www.youtube.com</a></p>
    <p>También puedes leer: <br>
      <a target="_blank" href="https://archivos.juridicas.unam.mx/www/bjv/libros/6/2713/61.pdf">archivos.juridicas.unam.mx</a></p>
  </div>
</template>

<script>
export default {
  name: "s12g09",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    },
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
